module.exports = __webpack_public_path__ + "img/homePei4.3696894a.png";